<!-- 人员管理 -->
<style lang="less">
    @media screen and (max-width:1599px) {
        #userManage .qy_class{  width: 107px; }
    }
    @media screen and (min-width:1600px) {
        #userManage .qy_class{  width: 162px; }
    }
    #userManage {

        .addBtn{
            float: left;
            text-align: left;
            margin-left: 20px;
            margin-top: 5px;
            margin-bottom: 5px;
        }
        .ml32{
            height: 36px;
            line-height: 36px;
        }
        .query-bar{
    		background: transparent;
    		height: 80px;
    		padding-top: 20px;
    		margin-bottom: 30px;
    		border-bottom: 1px solid #e9eaec;
    	}
    	.ivu-table-border td, .ivu-table-border th{
    		text-align: center;
    	}
    	.rightTop{
    		h4{
    			font-size: 18px;
    			color: #45AAF9;
    			float: left;
    			text-align: left;
    		}
    		text-align: left;
    		.ivu-form-item{
    			text-align: left;
    		}
    	}
        .ivu-form-item {
            margin-bottom: 0px;
        }

    }
    .ivu-page{
    	margin-top: 30px;
    }
    .width90{
        width: 90%!important;
    }
    .user_msg{
        .demo-upload-list{
            display: inline-block;
            width: 60px;
            height: 60px;
            text-align: center;
            line-height: 60px;
            border: 1px solid transparent;
            border-radius: 4px;
            overflow: hidden;
            background: #fff;
            position: relative;
            box-shadow: 0 1px 1px rgba(0,0,0,.2);
            margin-right: 4px;
        }
        .demo-upload-list img{
            width: 100%;
            height: 100%;
        }
        .demo-upload-list-cover{
            display: none;
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            background: rgba(0,0,0,.6);
        }
        .demo-upload-list:hover .demo-upload-list-cover{
            display: block;
        }
        .demo-upload-list-cover i{
            color: #fff;
            font-size: 20px;
            cursor: pointer;
            margin: 0 2px;
        }
    }

</style>


<template>
    <div id="userManage">
        <i-col span="24" style="padding: 0 20px;">
            <div class="query-bar">
                <Form inline class="rightTop" :label-width="80">
                	<h4>用户信息管理</h4>
                    <Button class="addBtn" @click="addUser" type="primary" style="margin-top: 0;">新增用户</Button>
                    <Form-item label="用户账号" prop="qy_username">
                        <Input  v-model="qy_username" class="qy_class"  :maxlength="16" placeholder="请输入账号"></Input>
                    </Form-item>
                    <Form-item label="用户名称" prop="qy_realname">
                        <Input  v-model="qy_realname" class="qy_class" :maxlength="16" placeholder="请输入名称"></Input>
                    </Form-item>
                    <Form-item label="用户角色" prop="qy_rolename">
                        <Select  v-model="qy_rolename" clearable class="qy_class">
                            <Option v-for="item in rolenameList" :value="item.rolename" :key="item.rolename">{{ item.rolename }}</Option>
                        </Select>
                    </Form-item>
                    <Form-item label="用户部门" prop="qy_department">
                        <Select  v-model="qy_department" clearable class="qy_class">
                            <Option v-for="item in departmentList" :value="item.name" :key="item.name">{{ item.name }}</Option>
                        </Select>
                    </Form-item>

                    <Button type="primary" @click="submitSearch(actionPage)">搜索</Button>
                </Form>
            </div>
            <Modal v-model="modal1"
                    class-name="user_msg">
                <div slot="header">{{updateTitle}}</div>
                <Form ref="userManagerForm" :model="formItem" :label-width="100" :rules="user_validate_rules">
                    <Form-item label="用户账号" prop="username">
                        <Input v-model="formItem.username" class="width90" :maxlength="16"  ></Input>
                    </Form-item>
                    <Form-item label="用户名称" prop="realname">
                        <Input v-model="formItem.realname" class="width90" :maxlength="16" placeholder="请输入名称"></Input>
                    </Form-item>
                    <Form-item v-show="hideIt" label="用户密码" prop="password">
                        <Input type="password" v-model="formItem.password" class="width90" :maxlength="16" placeholder="请输入密码"></Input>
                    </Form-item>
                    <!--<Form-item label="用户邮箱" prop="email">-->
                        <!--<Input v-model="formItem.email" class="width90"  placeholder="请输入邮箱"></Input>-->
                    <!--</Form-item>-->
                    <!--<Form-item label="手机" prop="mobile">-->
                        <!--<Input v-model="formItem.mobile" class="width90" :maxlength="11" placeholder="请输入联系方式"></Input>-->
                    <!--</Form-item>-->
                    <Form-item label="用户角色" prop="roles">
                        <Select multiple v-model="formItem.roles" clearable style="width:90%" >
                            <Option v-for="item in rolenameList" :value="item.roleid" :key="item.roleid">{{item.rolename}}</Option>
                        </Select>
                    </Form-item>
                    <!--<Form-item label="门禁卡号" prop="finger">-->
                        <!--<Input v-model="formItem.finger" class="width90" :maxlength="16" placeholder="请输入门禁卡号"></Input>-->
                    <!--</Form-item>-->
                    <!--<Form-item label="参加工作日期" prop="work_date">-->
                        <!--<DatePicker type="date"  v-model="formItem.work_date" format="yyyy-MM-dd" class="width90" placeholder="请选择日期" ></DatePicker>-->
                    <!--</Form-item>-->
                    <!--<Form-item label="入职日期" prop="entry_date">-->
                        <!--<DatePicker type="date"  v-model="formItem.entry_date" format="yyyy-MM-dd" class="width90" placeholder="请选择日期" ></DatePicker>-->
                    <!--</Form-item>-->
                    <!--<Form-item label="身份证" prop="identification">-->
                        <!--<Input v-model="formItem.identification" :maxlength="18" placeholder="请输入身份证" class="width90"></Input>-->
                    <!--</Form-item>-->
                    <div style="display: none;">
                        <Form-item label="电子签名">
                            <div class="demo-upload-list" v-if="url!=''">
                                <template>
                                    <img :src="url">
                                    <div class="demo-upload-list-cover">
                                        <Icon type="ios-eye-outline" @click.native="handleView"></Icon>
                                        <Icon type="ios-trash-outline" @click.native="handleRemove"></Icon>
                                    </div>
                                </template>
                                <!--<template v-else>-->
                                    <!--<Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress>-->
                                <!--</template>-->
                            </div>
                            <div v-if="picture">
                                <Upload
                                        ref="upload"
                                        :show-upload-list="false"
                                        :default-file-list="defaultList"
                                        :on-success="handleSuccess"
                                        :format="['png']"
                                        :max-size="10240"
                                        :on-format-error="handleFormatError"
                                        :on-exceeded-size="handleMaxSize"
                                        type="drag"
                                        :action='this.action'
                                        style="display: inline-block;width:58px;"
                                        >
                                    <div style="width: 58px;height:58px;line-height: 58px;">
                                        <Icon type="image" size="20"></Icon>
                                    </div>
                                </Upload>
                            </div>


                        </Form-item>
                    </div>

                </Form>
                <div slot="footer">
                    <Button v-if="btnSave" type="primary" @click="saveUser('userManagerForm')">保存</Button>
                    <Button v-if="btnChange" type="primary" @click="editUser('userManagerForm')">修改</Button>
                    <Button  @click="cancel">取消</Button>
                </div>
            </Modal>
            <Modal title="图片预览" v-model="visible">
                <img :src="imgName" v-if="visible" style="width: 100%">
            </Modal>

            <div class="center">
                <Table :data="UserData" :columns="theadArr" stripe></Table>
                <Page class="pull-right" :total="totalSize" :current="page" size="small" show-total @on-change="changePage"></Page>
            </div>
        </i-col>
    </div>
</template>


<script>
    export default {
        data () {
            const reEXP_username = /^[A-Za-z0-9]+$/;
            const reEXP_ID = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;//身份证正则
            const reEXP_mobile = /^1[0-9]{10}$/;
            const validate_username = (rule,value,callback) =>{
                if(value == ''){
                    callback(new Error('用户账号不能为空！'))
                }else if(!reEXP_username.test(value)){
                    callback(new Error('用户名只能包含字母和数字！'))
                }else {
                    /*this.checkName(function(res){
                        if(!res){
                            callback(new Error('该账号已被注册'))
                        }else {
                            callback();
                        }
                    })*/
                    callback();
                }
            };
            const validate_pwd = (rule,value,callback) =>{
                if(value ==''){
                    callback(new Error('密码不能为空！'))
                }else {
                    callback();
                }
            };
            const validate_realname = (rule,value,callback) =>{
                if(value == '') {
                    callback(new Error('用户名称不能为空！'))
                }else {callback()}
            };

            const validate_mobile = (rule,value,callback) =>{
                if(value == '') {
                    callback(new Error('手机号码不能为空！'))
                }else if (!reEXP_mobile.test(value)){
                    callback(new Error('手机号码格式不对!'))
                }else {callback()}
            };
            const validate_roles = (rule,value,callback) =>{
                if(!value.length > 0){
                    callback(new Error('角色不能为空！'))
                }else {callback()}
            };
//            const validator_ID = (rule,value,callback) =>{
//                if(value != '' && value != undefined){
//                    if(!reEXP_ID.test(value)){
//                        callback(new Error('身份证输入不合法!'))
//                    }else {
//                        callback();
//                    }
//                }else {
//                    callback();
//                }
//            }
//            const validate_finger = (rule,value,callback) =>{
//                if(value == '') {
//                    callback(new Error('门禁卡号不能为空！'))
//                }else {callback()}
//            };
//            const validate_work_date = (rule,value,callback) =>{
//
//                if(value == '') {
//                    callback(new Error('参加工作日期不能为空！'))
//                }else {callback()}
//            };
//            const validate_entry_date = (rule,value,callback) =>{
//                if(value == '') {
//                    callback(new Error('入职日期不能为空！'))
//                }else {callback()}
//            };
            return {
            	hideIt:false,
                user_validate_rules:{
                    username:[{required:true,validator:validate_username,trigger:'blur'}],
                    password:[{required:true,validator:validate_pwd,trigger:'blur'}],
                    realname:[{required:true,validator:validate_realname,trigger:'blur'}],
//                    email:[
//                        {required:true,message: '邮箱不能为空！',trigger:'blur'},
//                        { type: 'email', message: '邮箱格式不正确！', trigger: 'blur' }
//                    ],
//                    mobile:[{required:true,validator:validate_mobile,trigger:'blur'}],
                    roles:[{required:true,validator:validate_roles,trigger:'change'}],
//                    identification:[{validator:validator_ID,trigger:'blur'}],
//                    finger:[{required:true,validator:validate_finger,trigger:'blur'}],
//                    work_date:[{required:true,validator:validate_work_date,trigger:'change'}],
//                    entry_date:[{required:true,validator:validate_entry_date,trigger:'change'}],


                },
                urlUserList: "/sys/userinfo/search",
                urlAddUserList: "/sys/userinfo/new",
                urlUpdateUserList: "/sys/userinfo/edit",
                action:"/"+'/sys/userinfo/upload?token='+window.localStorage.getItem("token"),
                modal1: false,
                picture: true,
                isPassWord: false,
                actionPage: "1",
                btnChange: false,
                btnSave: false,
                changeRead: false,
                defaultList:[],
                imgName: '',
                imgUrl: '',
                path: '',
                url: '',
                visible: false,
                uploadList: [],
                updateTitle: "",
                qy_username:'',//查询条件：用户账号
                qy_realname:'',//查询条件：用户名
                qy_rolename:'',//查询条件：用户角色
                qy_department:'',//查询条件：用户部门
                totalSize:0,//总条数
                pageSize:10,//每页显示数
                page:1,//当前页
                UserData: [],
                rolenameList: [],
                departmentList: [],
                formItem: {roles:[]},
                theadArr: [{
                    title: "用户账号",
                    key: "username"
                }, {
                    title: "用户名称",
                    key: "realname"
                },  {
                    title: '用户角色',
                    key: 'role_show'
                }, {
                    title: '用户部门',
                    key: 'department'
                }, {
                    title: '用户操作',
                    align: 'center',
                    width: 200,
                    render: (h, params) => {
                        return h('div', [
                            h('Button', {
                                props: {
                                    type: 'primary',
                                    size: 'small'
                                },
                                style: {
                                    marginRight : '5px'
                                },
                                on: {
                                    click: () => {
                                        this.edit(params.row,params.index)
                                    }
                                }
                            }, '编辑'),
                            h('Button', {
                                props: {
                                    type: 'error',
                                    size: 'small'
                                },
                                on: {
                                    click: () => {
                                        this.delUser(params.row)
                                    }
                                }
                            }, '删除')
                        ]);
                    }
                }],
            }
        },
        methods:{
        	changQuery(){
        		this.submitSearch(this.actionPage)
        	},
            changePage: function(page) {
                this.submitSearch(page);
                this.actionPage = page;
            },
            //保存用户信息
            saveUser (formName) {
                let that = this;
                this.$refs[formName].validate((valid) =>{
                    if(valid) {
                        let params = {};
                        let roles = [];
                        params.url = that.urlAddUserList;
                        params.data = that.formItem;
                        params.data.work_date=new Date(that.formItem.work_date).format('yyyy-MM-dd');
                        params.data.entry_date=new Date(that.formItem.entry_date).format('yyyy-MM-dd');
                        params.data.openId = '';
                        params.token = window.localStorage.getItem("token");
                        params.data.signature_path = this.path;
                        console.log("params is ",params);
                        if(that.formItem.roles.length >0){
                            that.formItem.roles.map((item) =>{
                                for(let i = 0;i<that.rolenameList.length;i++){
                                    if(that.rolenameList[i].roleid != item) continue;
                                    let role = {roleid:that.rolenameList[i].roleid,rolename:that.rolenameList[i].rolename};
                                    roles.push(role)
                                }
                            })
                            params.data.roles = roles;
                        }else{
                            this.$Notice.warning({
                                title: '请选择角色'
                            });
                            return;
                        }
                        params.success=function(res){
                            res = res.data;
                            console.log(res);
                            if(res.code == '0000') {
                                that.$Message.success({
                                    content: '新增成功'
                                });
                                that.modal1=false;
                                that.path='';
                                that.submitSearch(parseInt(that.actionPage));
                            }else{
                              that.$Message.error({
                                content: res.message
                              });
                            }
                        };
                        params.error = function (res) {
                            if(res.code == '0002') {
                                that.$Message.error({
                                    content: res.message
                                });
                            }
                        }
                          that.ajaxPost(params);
                    }
                })
            },
            cancel () {
                this.modal1=false;
            },
            getRoleNameList: function() {
                var that = this;
                let params = {};
                params.data = {}
                params.url = '/sys/role/list';
                params.token = window.localStorage.getItem("token");
                params.success = function(res) {
                    res = res.data;
                    that.rolenameList = res.result.result;
                }
                this.ajaxPost(params);
            },
            getDepartmentList: function() {
                var that = this;
                let params = {};
                params.data = {}
                params.url = '/sys/department/list';
                params.token = window.localStorage.getItem("token");
                params.success = function(res) {
                  res = res.data;
                  that.departmentList = res.result.result;
                }
                this.ajaxPost(params);
            },
            submitSearch: function (page) {
                page = page == '' || page == undefined ? this.page:page;
                let that = this;
                let params = {};
                params.data = {page:page, pageSize:this.pageSize, order:{'_id':-1},department_name : '', rolename : '', username : '', realname : '' }
                params.url = '/sys/userinfo/search';
                params.token = window.localStorage.getItem("token");
                if(this.qy_username !=''){
                    params.data.username=this.qy_username;
                }
                if(this.qy_realname !=''){
                    params.data.realname=this.qy_realname;
                }
                if(this.qy_rolename !=''){
                    params.data.rolename = this.qy_rolename;
                }
                if(this.qy_department !=''){
                    params.data.department_name = this.qy_department;
                }
                params.success = function(res) {
                    console.log(res)
                    res = res.data;
                    that.UserData = res.result.result;
                    that.totalSize = res.result.totalSize;
                    that.page = res.result.page;
                }
                this.ajaxPost(params);
            },
            addUser: function() {
                this.formItem = {
                    username:'',
                    password:'',
                    realname:'',
                    email:'',
                    mobile:'',
                    roles:[],
                    departmentName:'',
                    identification:'',
                    finger:'',
                    work_date:'',
                    entry_date:'',
                };
                this.hideIt = true;
                this.updateTitle = "新增用户";
                this.btnChange = false;
                this.btnSave = true;
                this.modal1 = true;
                this.changeRead = false;
                this.uploadList=[];
                this.path='';
                this.url='';
                this.isPassWord = true;
                this.picture=true
            },
            edit: function(row,index) {
            	console.log(row);
                this.hideIt = false;
                let that = this;
                this.updateTitle = "编辑用户";
                this.btnSave = false;
                this.btnChange = true;
                this.isPassWord = false;
                this.modal1 = true;
                this.changeRead = true;
                this.formItem = JSON.parse(JSON.stringify(row));
                this.formItem.identification = this.formItem.identification == '' || this.formItem.identification == undefined?'':this.formItem.identification;
                delete this.formItem['_index'];
                delete this.formItem['_rowKey'];
                this.formItem.roles =[];
                if(this.UserData[index].signature_path!=''){
                    this.picture=false;
                    this.url="/"+this.UserData[index].signature_path+'?token='+window.localStorage.getItem("token");
                }else{
                    this.picture=true;
                    this.url=''
                }
                if(row.roles.length >0) {
                    row.roles.map((item) =>{
                        that.formItem.roles.push(item.roleid)
                    })
                }
//                this.$refs.upload.fileList=this.UserData[index].uploadList;
            },
            //保存修改用户
            editUser: function(formName) {
                let that = this;
                this.$refs[formName].validate((valid) =>{
                    if(valid){
                        let params = {};
                        params.data = this.formItem;
                        params.url = this.urlUpdateUserList;
                        params.data.signature_path = this.path;
                        console.log(this.role_show);
                        params.token = window.localStorage.getItem("token");
                        let roles = [];
                        if(this.formItem.roles.length >0){
                            this.formItem.roles.map((item) =>{
                                for(let i = 0;i<that.rolenameList.length;i++){
                                if(that.rolenameList[i].roleid != item) continue;
                                    let role = {roleid:that.rolenameList[i].roleid,rolename:that.rolenameList[i].rolename};
                                    roles.push(role)
                                }
                            })
                            params.data.roles = roles;
                        }else{
                            this.$Notice.warning({
                                title: '请选择角色'
                            });
                            return;
                        }
                        console.log("params is ",params)
                        params.success=function(res){
                          res = res.data;
                            if(res.code == '0000') {
                                that.$Message.success({
                                    content: '修改成功'
                                });
                                that.path='';
                                that.modal1=false;
                            }else{
                              that.$Message.error({
                                content: res.message
                              });
                            }
                            that.submitSearch(that.actionPage)
                        }
                        that.ajaxPost(params);
                    }
                })
            },
            //删除用户信息
            delUser: function(data) {
                console.log(data);
                let that = this;
                this.$Modal.confirm({
                    content:'确认删除该个用户？',
                    onOk:function () {
                        var params = {};
                        params.data = {};
                        params.data._id = data._id.toString();
                        params.data.username = data.username;
                        params.token = window.localStorage.getItem("token");
                        params.url = '/sys/userinfo/delete';
                        params.success=function(res){
                        res = res.data
                        switch(res.code) {
                            case '0000':
                                that.$Message.success({
                                    content: '删除成功'
                                });
                                that.path='';
                                break;
                                default:
                                that.$Message.warning({
                                    content: res.message + " 删除失败"
                                });
                        }
                        that.submitSearch(parseInt(that.actionPage));
                      };
                       that.ajaxPost(params);
                    }
                })
            },
            //验证用户名是否可用
            checkName: function(callback) {
                let that = this;
                let params = {};
                params.data = {}
                params.data.username = this.formItem.username;
                params.token = window.localStorage.getItem("token");
                params.url = this.urlUserList;
                params.success = function(res) {
                    res = res.data
                    if(parseInt(res.result.totalSize) != 0){
                        callback(false)
                    }else{
                        callback(true)
                    }
                };
                params.error = function (res) {
                    callback(false);
                }
               this.ajaxPost(params);
            },
            handleView () {
//                console.log(url);
                this.imgName = this.url;
                this.visible = true;
            },
            handleRemove () {
                console.log(this.uploadList);
                this.uploadList=[];
                this.url='';
                this.path='';
//                const fileList = this.$refs.upload.fileList;
//                this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
                this.picture=true;

            },
            handleSuccess (res, file) {
                console.log(res);
                console.log(file);
                this.path=res.result.path;
                file.url ="/"+this.path+'?token='+window.localStorage.getItem("token");;
                file.name = res.result.filename;
                this.url="/"+this.path+'?token='+window.localStorage.getItem("token");
                this.picture=false;
            },
            handleFormatError (file) {
                this.$Notice.warning({
                    title: '图片格式不对',
                    desc: '图片 ' + file.name + ' 格式不对，请选择png格式的图片上传'
                });
            },
            handleMaxSize (file) {
                this.$Notice.warning({
                    title: '超出大小范围',
                    desc: '图片 ' + file.name + ' 大小不能超过10M'
                });
            },
        },
        mounted: function() {
            console.log(999);
            this.uploadList = this.$refs.upload.fileList;
            this.submitSearch(this.page);
            this.getRoleNameList();
            this.getDepartmentList();
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/userMana/userInfo.vue